import commonJsModule from "array-to-object-keys"

export const {parallel} = commonJsModule
export default commonJsModule.default